<template>
  <div class="folders-actions pt-8">
    <div>
      <div class="container-fluid">
        <div class="row m-0 flex-no-wrap justify-between items-center">
          <div class="col-auto">
            <Breadcrumbs :folder="folder" v-if="folder.parent"></Breadcrumbs>
          </div>
          <div class="col-auto">
            <DropdownCreateItem @CreateItem="createItem($event)" />
          </div>
        </div>
      </div>

      <div class="row mx-0 mt-10 justify-between items-center pr-8">
        <div class="col-auto">
          <div class="folders-actions__selector flex px-4" v-show="selectMode">
            <CheckboxVue
              id="folder-1"
              name="folder"
              type="checkbox"
              :value="false"
              @input="toggleSelectAll"
            />
            <ul v-if="anyChecked" class="flex">
              <li>
                <button
                  type="button"
                  class="p-2 pl-4 text-gray-600 uppercase font-bold text-sm cursor-pointer"
                  @click="moveToFolder"
                >
                  <IconFolder class="h-5 inline-block" /> Sposta in
                </button>
              </li>
              <li>
                <button
                  type="button"
                  class="p-2 text-gray-600 uppercase font-bold text-sm cursor-pointer"
                  @click="deleteChecked"
                >
                  <IconTrash class="h-5 inline-block" /> Cancella
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-auto">
          <ul class="row m-0">
            <li class="col-auto">
              <button
                class="text-gray-700 p-4"
                :class="{ 'text-gray-900': selectMode }"
                @click="toggle()"
              >
                Seleziona
                <IconCloseCircle
                  class="inline-block ml-1 h-5"
                  v-if="selectMode"
                />
              </button>
            </li>

            <li class="col-auto">
              <button
                type="button"
                class="text-gray-700 p-4"
                :class="{ 'text-gray-900': sortMode === 'asc' }"
                @click="toggleSort('asc')"
              >
                Ordina per meno recenti
              </button>
            </li>

            <li class="col-auto">
              <button
                class="text-gray-700 p-4 pr-0"
                :class="{ 'text-gray-900': sortMode === 'desc' }"
                @click="toggleSort('desc')"
              >
                Ordina per più recenti
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <Modal ref="createModal">
      <CreateItem
        :itemType="itemToCreate"
        :folderId="folder._id"
        @CreateItem="$refs.createModal.close()"
      />
    </Modal>
  </div>
</template>

<script>
/** Components */
import Breadcrumbs from '@/components/Breadcrumbs.vue'
import CheckboxVue from '@/components/fields/CheckboxVue.vue'
import CreateItem from '@/components/CreateItem.vue'
import DropdownCreateItem from '@/components/DropdownCreateItem.vue'
import Modal from '@/components/Modal.vue'
import IconCloseCircle from '@/assets/icons/icon-close_circle.svg'

import IconTrash from '@/assets/icons/icon-trash.svg'
import IconFolder from '@/assets/icons/icon-folder.svg'

export default {
  components: {
    Breadcrumbs,
    CheckboxVue,
    CreateItem,
    DropdownCreateItem,
    Modal,
    IconCloseCircle,
    IconTrash,
    IconFolder,
  },

  props: {
    folder: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      itemToCreate: '',
    }
  },

  computed: {
    selectMode() {
      return this.$store.state.folders.selectMode
    },
    sortMode() {
      return this.$store.state.folders.sortMode
    },
    anyChecked() {
      return (
        this.$store.state.folders.checkedFolders.length ||
        this.$store.state.folders.checkedPodcasts.length
      )
    },
  },

  methods: {
    toggle() {
      this.$store.commit('folders/toggleSelectMode')
    },

    createItem(type) {
      this.itemToCreate = type
      this.$refs.createModal.open()
    },

    toggleSort(mode) {
      if (mode === this.sortMode) {
        this.$store.commit('folders/setSortMode', '')
      } else {
        this.$store.commit('folders/setSortMode', mode)
      }
    },

    toggleSelectAll(checked) {
      this.$emit('selectAll', checked)
    },

    deleteChecked() {
      if (confirm('Cancellare definitivamente gli elementi selezionati?')) {
        this.$emit('deleteAll')
      }
    },

    moveToFolder() {
      this.$emit('moveToFolder')
    },
  },
}
</script>

<style lang="scss" scoped></style>
